import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatDividerModule } from '@angular/material/divider';
import { CfaLoadingModule } from '@app/shared/components/loading/cfa-loading-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { throwIfAlreadyLoaded } from '@app/core/guards/module-import.guard'
import { RouterModule } from '@angular/router';
import { ErrorDialogComponent } from '@app/shared/dialogs/error-dialog/error-dialog.component';
import { ConfirmationDialogComponent } from '@app/shared/dialogs/confirmation-dialog/confirmation-dialog.component';
import { ComponentAnchorDirective } from '@shared/directives/component-anchor.directive';
import {BreadcrumbsComponent} from '@shared/components/breadcrumbs/breadcrumbs.component';
import {CleanHtmlPipe} from '@shared/pipes/clean-html.pipe';
import {ErrorModalComponent} from '@shared/dialogs/error-modal/error-modal.component';
import { LayoutModule } from '@angular/cdk/layout';
import {SortPipe} from '@shared/pipes/sort.pipe';
import {DateFormatPipe} from '@shared/pipes/date-format.pipe';
import { MessageDialogComponent } from './dialogs/message-dialog/message-dialog.component';
import { ErrorDetailModalComponent } from './dialogs/error-detail-modal/error-detail-modal.component';
import { WelcomeDialogComponent } from './dialogs/welcome-dialog/welcome-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        MatAutocompleteModule,
        MatTabsModule,
        MatDividerModule,
        MatExpansionModule,
        MatSliderModule,
        MatSelectModule,
        MatRadioModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatSnackBarModule,
        MatIconModule,
        MatBadgeModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatButtonModule,
        MatSortModule,
        MatTableModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatPaginatorModule,
        MatSlideToggleModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        CfaLoadingModule,
        MatGridListModule,
        MatMenuModule,
        LayoutModule,
        MatTooltipModule
    ],
    exports: [
        CfaLoadingModule,
        MatAutocompleteModule,
        MatTabsModule,
        MatDividerModule,
        MatExpansionModule,
        MatSliderModule,
        MatSelectModule,
        MatRadioModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatSnackBarModule,
        MatIconModule,
        MatBadgeModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatButtonModule,
        MatSortModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatCardModule,
        MatTableModule,
        MatFormFieldModule,
        MatInputModule,
        MatPaginatorModule,
        MatSlideToggleModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ConfirmationDialogComponent,
        MessageDialogComponent,
        WelcomeDialogComponent,
        ComponentAnchorDirective,
        BreadcrumbsComponent,
        ErrorDialogComponent,
        ErrorModalComponent,
        ErrorDetailModalComponent,
        CleanHtmlPipe,
        MatGridListModule,
        MatMenuModule,
        LayoutModule,
        SortPipe,
        MatTooltipModule,
        DateFormatPipe
    ],
    declarations: [
        ConfirmationDialogComponent,
        MessageDialogComponent,
        WelcomeDialogComponent,
        ErrorDialogComponent,
        ErrorModalComponent,
        ErrorDetailModalComponent,
        ComponentAnchorDirective,
        BreadcrumbsComponent,
        CleanHtmlPipe,
        SortPipe,
        DateFormatPipe
    ],
    schemas: []
})
export class SharedModule {
    constructor(@Optional() @SkipSelf() parentModule: SharedModule) {
        throwIfAlreadyLoaded(parentModule, 'SharedModule');
    }
}